import { DISTRICTURL } from "helpers/constant";
import { callApi } from "Apis";
import { TALUKAURL } from "helpers/constant";
import { VILLAGEURL } from "helpers/constant";

// District Add Api...
export async function addDistrictApi(data) {
  try {
    const response = await callApi({
      url: DISTRICTURL.ADD,
      body: data,
      method: "POST",
    });
    return response;
  } catch (err) {
    throw err;
  }
}

// District Add Api...
export async function addDistrict(data) {
  try {
    const response = await callApi({
      url: DISTRICTURL.ADD_DISTRICT,
      body: data,
      method: "POST",
    });
    return response;
  } catch (err) {
    throw err;
  }
}

// District Update Api...
export async function updateDistrictApi(data) {
  try {
    const response = await callApi({
      url: DISTRICTURL.UPDATE,
      body: data,
      method: "PUT",
    });
    return response;
  } catch (err) {
    throw err;
  }
}

// District Delete Api...
export async function districtDelete(id) {
  try {
    const response = await callApi({
      url: DISTRICTURL.DELETE(id),
      method: "DELETE",
    });
    return response;
  } catch (err) {
    throw err;
  }
}

// District get by id Api...
export async function getDistrictDetailById(id) {
  try {
    const response = await callApi({
      url: DISTRICTURL.GET(id),
      method: "GET",
    });
    return response;
  } catch (err) {
    throw err;
  }
}

//  ----------------- Taluka Apis -------------------

// Taluka Add Api...
export async function addTalukaApi(data) {
  try {
    const response = await callApi({
      url: TALUKAURL.ADD,
      body: data,
      method: "POST",
    });
    return response;
  } catch (err) {
    throw err;
  }
}

// Taluka Update Api...
export async function updateTalukaApi(data) {
  try {
    const response = await callApi({
      url: TALUKAURL.UPDATE,
      body: data,
      method: "PUT",
    });
    return response;
  } catch (err) {
    throw err;
  }
}

// Taluka Delete Api...
export async function talukaDelete(id) {
  try {
    const response = await callApi({
      url: TALUKAURL.DELETE(id),
      method: "DELETE",
    });
    return response;
  } catch (err) {
    throw err;
  }
}

// Taluka get by id Api...
export async function getTalukaDetailById(id) {
  try {
    const response = await callApi({
      url: TALUKAURL.GET(id),
      method: "GET",
    });
    return response;
  } catch (err) {
    throw err;
  }
}

//  ----------------- Village Apis --------------

// Village Add Api...
export async function addVillageApi(data) {
  try {
    const response = await callApi({
      url: VILLAGEURL.ADD,
      body: data,
      method: "POST",
    });
    return response;
  } catch (err) {
    throw err;
  }
}

// Village Update Api...
export async function updateVillageApi(data) {
  try {
    const response = await callApi({
      url: VILLAGEURL.UPDATE,
      body: data,
      method: "PUT",
    });
    return response;
  } catch (err) {
    throw err;
  }
}

// Village Delete Api...
export async function villageDelete(id) {
  try {
    const response = await callApi({
      url: VILLAGEURL.DELETE(id),
      method: "DELETE",
    });
    return response;
  } catch (err) {
    throw err;
  }
}

// Village get by id Api...
export async function getVillageDetailById(id) {
  try {
    const response = await callApi({
      url: VILLAGEURL.GET(id),
      method: "GET",
    });
    return response;
  } catch (err) {
    throw err;
  }
}
